module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger1-2c76cfce.png";